export default __webpack_public_path__ + "static/throwing-2065ce7525082190662267d525b6eaae.svg";